import React, { useEffect, useState } from "react";
import {contestDummyBanners, DOCUMENTSLIST, dummyBanners, PRODUCTLIST, SUPPORTLIST} from "../home.constant";
import { Network } from "../../../utils/network";
import { TabActions, useNavigation } from "@react-navigation/native";
import PlatformSpecificBanner from "./PlatformSpecificBanner";
import {
    atob,
    isMobile, openURL,
    trackMoengageEvent,
} from "../../../utils/commonMethods";
import {Linking, Text, TouchableOpacity, View} from "react-native";
import { deepLinkConst, deeplinkTabs } from "../../../common/dynamicLinkConst";
import { globalImport } from "../../../common/globalImports";
import {globalConfigurableData, GlobalScreens} from "../../../utils/globalConstant";
import {Color, globalFontStyle} from "../../../assets";
import FormTextLabel from "../../../commonComponents/FormTextLabel";
import FastImage from "../../../common/FastImage";
import {
    androidFooter,
    check,
    ficciFooter,
    instaFooter,
    iosFooter,
    xFooter,
    ycFooter,
    youtubeFooter
} from "../../../utils/images";
import Width from "../../../assets/Width";

const HomeFooter = ({onLearnMore, isLoadProbe, screen, globalConfigData}) => {


    function listComponent (title, list) {
        return (
            <View style={{flex: 1}}>
                <Text
                    style={[
                        globalFontStyle.appFontHeading,
                        {
                            color: globalConfigurableData.primaryTextColor1,
                            paddingBottom: 3,
                            paddingTop: isMobile() ? 17 : 0
                        },
                    ]}
                    numberOfLines={1}>
                    {title}
                </Text>
                {list?.map((item, i) => {
                    return (
                        <TouchableOpacity key={i} onPress={() => openURL(item?.link)}>
                            <FormTextLabel
                                labelStyles={[
                                    globalFontStyle.appFontSubText,
                                    {
                                        color: "#3E3E3E",
                                        paddingTop: 12
                                    },
                                ]}
                                label={item?.title}
                            />
                        </TouchableOpacity>
                    );
                })}
            </View>
        );
    }

    function ycComponent() {
        return (
            <View style={isMobile() ? {paddingTop: 20} : {flex: 1}}>
                    <FastImage
                        style={isMobile() ? {height : 40, width: 225} : {height : 37, width: 200,}}
                        source={ycFooter()}
                    />
                    <FastImage
                        style={isMobile() ? {height : 40, width: 190, marginTop: 12} : {height : 37, width: 170, marginTop: 12}}
                        source={ficciFooter()}
                    />
            </View>
        );
    }

    function downloadComponent() {
        return (
            <View style={isMobile() ? {} : {flex: 1}}>
                <Text
                    style={[
                        globalFontStyle.appFontHeading,
                        {
                            color: globalConfigurableData.primaryTextColor1,
                            paddingBottom: 5,
                            paddingTop: isMobile() ? 17 : 0
                        },
                    ]}
                    numberOfLines={1}>
                    {"Get the app"}
                </Text>
                <View style={isMobile() ? {
                    flexDirection: "row",
                    justifyContent: "space-between",
                } : {
                    flexDirection: "column",
                }}>
                    <TouchableOpacity onPress={() => openURL("https://apps.apple.com/in/app/tradex-markets/id1608795674")}>
                        <FastImage
                            style={isMobile() ? {width: Width.width/2-23.5, height: 55, marginTop: 15} : {height : 60, width: 170}}
                            source={iosFooter()}
                        />
                    </TouchableOpacity>
                    <TouchableOpacity onPress={() => openURL("https://api.tradexapp.co/getapplication")}>
                        <FastImage
                            style={isMobile() ? {width: Width.width/2-23.5, height: 55, marginTop: 15} : {height : 60, width: 170}}
                            source={androidFooter()}
                        />
                    </TouchableOpacity>
                </View>
            </View>
        );
    }

    function socialComponent() {
        return (
            <View style={isMobile() ? {} : {
                flexDirection: "row",
                justifyContent: "space-between"
            }}>
                <Text
                    style={[
                        globalFontStyle.appFontSubText,
                        {
                            color: globalConfigurableData.primaryTextColor1,
                            paddingTop: 17
                        },
                    ]}
                    numberOfLines={1}>
                    {"2025 © TradeX Software India Private Limited"}
                </Text>
                <View style={{
                    paddingTop: 20,
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 15
                }}>
                    <TouchableOpacity onPress={() => openURL("https://www.instagram.com/tradex_markets/")}>
                        <FastImage
                            style={{width: 28, height: 28,}}
                            source={instaFooter()}
                        />
                    </TouchableOpacity>
                    <TouchableOpacity onPress={() => openURL("https://x.com/TradeXApp")}>
                        <FastImage
                            style={{width: 23, height: 23}}
                            source={xFooter()}
                        />
                    </TouchableOpacity>
                    <TouchableOpacity onPress={() => openURL("https://www.youtube.com/@TradeXApp")}>
                        <FastImage
                            style={{width: 30, height: 30}}
                            source={youtubeFooter()}
                        />
                    </TouchableOpacity>
                </View>
            </View>
        );
    }

    return (
        <>
        <View
            style={{
                paddingBottom: isMobile() ? 60 : 30,
                paddingTop: 25,
                marginTop: 30,
                backgroundColor: GlobalScreens.Home.hashTagBgColor,
                paddingHorizontal: isMobile() ? 16 : 0,
            }}>
            <View
                style={{
                    paddingBottom: 30,
                }}>
                {isMobile() ? (
                    <View>
                        {downloadComponent()}
                        {ycComponent()}
                        <View style={{
                            flexDirection: "row"
                        }}>
                            {listComponent("Product", PRODUCTLIST)}
                            {listComponent("Support", SUPPORTLIST)}
                        </View>
                        {listComponent("Documents", DOCUMENTSLIST)}
                    </View>
                ) :
                    (<View>
                            <View style={{
                                flexDirection: "row"
                            }}>
                                {ycComponent()}
                                {listComponent("Product", PRODUCTLIST)}
                                {listComponent("Support", SUPPORTLIST)}
                                {listComponent("Documents", DOCUMENTSLIST)}
                                {downloadComponent()}
                            </View>
                </View>)

                }
            </View>
            <View style={{width: "100%", height: .75, backgroundColor: Color.black}}/>
            {socialComponent()}
        </View>
        </>
    );
};

export default HomeFooter;
